import { useEffect, useState } from 'react'
import { capitalize, splitByUppercase } from '../../../utils/text.js'
import { DateInput } from '../../DateInput/index.js'
import { prettyDate } from '@based/pretty-date'

export const TimeStampType = ({
  value,
  onChange,
  schemaProp,
  name,
  disabled,
}) => {
  const {
    title,
    description,
    readOnly,
    default: defaultValue,
    on,
    display,
  } = schemaProp

  const displayValue =
    readOnly && display
      ? prettyDate(value || defaultValue, display)
      : value || defaultValue

  return (
    <DateInput
      variant={display === 'date' ? 'date' : 'date-time'}
      value={value || defaultValue}
      placeholder={
        displayValue || (display === 'date' ? 'Pick date' : 'Pick date & time')
      }
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      description={description}
      disabled={
        readOnly || name === 'createdAt' || name === 'updatedAt' || disabled
      }
    />
  )
}
